import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import { loadStudents } from '../utils/farmApi.mjs';
import { mapFarmError } from '../utils/farmState.mjs';

export default {
  oninit(vnode) {
    this.rows = [];
    this.page = 1;
    this.hasMore = false;
    this.loading = true;
    this.error = '';
    this.nickname = '';
    this.filter = 'all';
    this.load(vnode);
  },
  load(vnode, append = false) {
    this.loading = true;
    return loadStudents(vnode.attrs.app, { nickname: this.nickname, filter: this.filter, page: this.page }, vnode.attrs.basePath)
      .then((response) => {
        const data = response?.data || response || {};
        this.rows = append ? this.rows.concat(data.rows || []) : (data.rows || []);
        this.hasMore = Boolean(data.hasMore);
        this.error = '';
      })
      .catch((error) => { this.error = mapFarmError(error); })
      .finally(() => { this.loading = false; m.redraw(); });
  },
  view(vnode) {
    return (
      <section className="YingtaoFarmPanel" aria-labelledby="yingtao-students-title">
        <header className="YingtaoFarmPanel-header"><h2 id="yingtao-students-title">同学农场</h2></header>
        <div className="YingtaoStudentFilters">
          <input className="FormControl" type="search" value={this.nickname} placeholder="搜索昵称" oninput={(event) => { this.nickname = event.target.value; }} onkeydown={(event) => { if (event.key === 'Enter') { this.page = 1; this.load(vnode); } }} />
          <select className="FormControl" value={this.filter} onchange={(event) => { this.filter = event.target.value; this.page = 1; this.load(vnode); }}>
            <option value="all">全部</option><option value="mature">有成熟作物</option><option value="needs_help">需要帮助</option>
          </select>
          <Button className="Button" icon="fas fa-search" onclick={() => { this.page = 1; this.load(vnode); }}>搜索</Button>
        </div>
        {this.error ? <div className="Alert Alert--error" role="alert">{this.error}</div> : null}
        {this.loading && !this.rows.length ? <LoadingIndicator /> : null}
        {!this.loading && !this.rows.length ? <Placeholder text="还没有可访问的同学农场。" /> : null}
        <div className="YingtaoStudentList">{this.rows.map((row) => <button type="button" className="YingtaoStudentRow" key={row.id} onclick={() => vnode.attrs.onSelect(row.id)}><span>{row.nickname}</span><small>等级 {row.level}{row.hasMatureCrops ? ' · 有成熟作物' : ''}</small></button>)}</div>
        {this.hasMore ? <Button className="Button Button--link" loading={this.loading} onclick={() => { this.page += 1; this.load(vnode, true); }}>加载更多</Button> : null}
      </section>
    );
  },
};
